import { render, staticRenderFns } from "./popup_info.vue?vue&type=template&id=59b05aa7&"
import script from "./popup_info.vue?vue&type=script&lang=js&"
export * from "./popup_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports